import ConnectedWorkoutApp, {
  HREventListener, IPrepareHomeWorkout, IPrepareStudioWorkout, UnRegisterEventListener,
} from './connected-workout-app';

/**
 * Base class for ConnectedWorkoutApp that does not implement a real-time HR monitor or a
 * real time workout tracking (ie, completed workouts are _saved_ only)
 */
export default abstract class BaseNonRealTimeConnectedApp extends ConnectedWorkoutApp {
  private realTime = false;

  public async isAppInstalledOnConnectedDevice(): Promise<boolean> {
    return this.realTime;
  }

  public async isConnectedDeviceAvailable(): Promise<boolean> {
    return this.realTime;
  }

  public async isConnectedDeviceAvailable(): Promise<boolean> {
    return this.realTime;
  }

  public async canUseAsRealtimeHeartRateMonitor(): Promise<boolean> {
    return this.realTime;
  }

  public registerHREventHandler(listener: HREventListener): UnRegisterEventListener {
    return () => { /* no-op */ };
  }

  public prepareHomeWorkout(options: IPrepareHomeWorkout): Promise<void> {
    return this.noOp();
  }

  public prepareStudioWorkout(options: IPrepareStudioWorkout): Promise<void> {
    return this.noOp();
  }

  public startWorkout(): Promise<void> {
    return this.noOp();
  }

  public stopAndDiscardWorkout(): Promise<void> {
    return this.noOp();
  }

  public pauseWorkout(): Promise<void> {
    return this.noOp();
  }

  public resumeWorkout(): Promise<void> {
    return this.noOp();
  }

  private async noOp() {
    // nothing
  }
}
